import { createContext, useContext } from 'react'

/**
 * Controls which color scheme StagePill uses.
 *
 * - "win_rate" (default): green-to-red gradient based on stage win_rate
 * - "pipeline": indigo gradient based on stage position in the pipeline
 */
type StageColorMode = 'win_rate' | 'pipeline'

const StageColorContext = createContext<StageColorMode>('win_rate')

export const StageColorProvider = StageColorContext.Provider

export function useStageColorMode(): StageColorMode {
  return useContext(StageColorContext)
}
